import { render } from "./readPenitentiary.vue?vue&type=template&id=d04e8770"
import script from "./readPenitentiary.vue?vue&type=script&lang=js"
export * from "./readPenitentiary.vue?vue&type=script&lang=js"

import "./readPenitentiary.vue?vue&type=style&index=0&id=d04e8770&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__